<template>
  <div v-if="open" class="tm-backdrop" role="dialog" aria-modal="true" aria-labelledby="tm-resched-title" @click.self="$emit('close')">
    <div class="tm-modal">
      <div class="tm-modal-header">
        <div>
          <h5 id="tm-resched-title" class="mb-0 font-weight-bold text-white"><i class="fe fe-calendar mr-2"></i>Change consultation</h5>
          <small class="text-white" style="opacity:.8;">Doctor, date or time. The doctor and the patient are told and their calendars updated.</small>
        </div>
        <button type="button" class="tm-close" aria-label="Close" @click="$emit('close')"><i class="fe fe-x"></i></button>
      </div>

      <form class="tm-modal-body" @submit.prevent="save">
        <div class="form-group">
          <label for="rs-doctor" class="tm-label">Doctor</label>
          <select id="rs-doctor" v-model="professionalId" class="form-control">
            <option value="">Any available doctor</option>
            <option v-for="d in doctors" :key="d.id" :value="d.id">{{ d.name }}{{ d.specs }}</option>
          </select>
        </div>

        <SlotPicker v-model="slot" :facility-id="consultation.provider_id" :professional-id="professionalId || null"
          :except-id="consultation.id" :initial-date="consultation.appointDate" />

        <div class="form-group mt-2">
          <label for="rs-reason" class="tm-label">Reason <span class="text-muted small">(optional, replaces the current one)</span></label>
          <textarea id="rs-reason" v-model="reason" rows="2" class="form-control"></textarea>
        </div>

        <div v-if="error" class="alert alert-danger small py-2">{{ error }}</div>

        <div class="d-flex justify-content-end" style="gap: 10px;">
          <button type="button" class="btn btn-light" @click="$emit('close')">Cancel</button>
          <button type="submit" class="btn tm-btn" :disabled="saving || !slot">
            <span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status"></span>Save changes
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SlotPicker from "./SlotPicker.vue";

// Emits `saved` with the updated consultation.
export default {
  name: "RescheduleConsultation",
  components: { SlotPicker },
  props: {
    open: { type: Boolean, default: false },
    consultation: { type: Object, required: true },
  },
  data() {
    return {
      doctors: [],
      professionalId: this.consultation.professional_id || "",
      slot: null,
      reason: "",
      saving: false,
      error: "",
    };
  },
  watch: {
    open(value) {
      if (value && !this.doctors.length) this.loadDoctors();
    },
  },
  methods: {
    loadDoctors() {
      this.axios.get("/api/v1/auth/telemedicine/facilities").then((res) => {
        const f = (res.data.data || []).find((x) => Number(x.id) === Number(this.consultation.provider_id));
        if (!f) return;
        const specs = (x) => ((x.specializations || []).length ? " — " + x.specializations.map((s) => s.name).join(", ") : "");
        const facilityName = `${f.firstname || ""} ${f.lastname || ""}`.trim();
        this.doctors = [
          { id: f.id, name: facilityName && facilityName.toLowerCase() !== "nil nil" ? `Dr ${facilityName}` : f.agency_name, specs: specs(f) },
          ...(f.doctors || []).map((d) => ({ id: d.id, name: `Dr ${d.firstname} ${d.lastname}`, specs: specs(d) })),
        ];
      });
    },
    save() {
      this.error = "";
      this.saving = true;
      this.axios
        .put(`/api/v1/auth/telemedicine/consultations/${this.consultation.id}`, {
          professional_id: this.slot.professional_id,
          appointDate: this.slot.date,
          appoinTime: this.slot.time,
          reason: this.reason || null,
        })
        .then((res) => {
          this.$toasted.success(res.data.message || "Consultation updated", { position: "top-center", duration: 4000 });
          this.$emit("saved", res.data.data);
          this.$emit("close");
        })
        .catch((err) => {
          const d = (err.response && err.response.data) || {};
          this.error = d.errors ? Object.values(d.errors).flat().join(" ") : d.message || "Could not change the consultation.";
        })
        .finally(() => (this.saving = false));
    },
  },
};
</script>

<style scoped>
.tm-backdrop { position: fixed; inset: 0; background: rgba(15, 23, 42, .55); z-index: 1050; display: flex; align-items: flex-start; justify-content: center; padding: 40px 12px; overflow-y: auto; }
.tm-modal { background: #fff; border-radius: 16px; width: 100%; max-width: 640px; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,.25); }
.tm-modal-header { display: flex; justify-content: space-between; align-items: flex-start; padding: 20px 24px; background: linear-gradient(135deg, #4c1d95, #7c3aed); }
.tm-close { background: rgba(255,255,255,.15); border: none; border-radius: 8px; color: #fff; width: 32px; height: 32px; }
.tm-modal-body { padding: 20px 24px; }
.tm-label { font-weight: 600; font-size: .85rem; color: #374151; }
.tm-btn { background: linear-gradient(135deg, #4c1d95, #7c3aed); color: #fff; border: none; border-radius: 8px; font-weight: 600; padding: 8px 20px; }
.tm-btn:hover { opacity: .9; color: #fff; }
</style>
